import * as config from '@/config.json'

import Loading from 'vue-loading-overlay'
import TableSkeleton from '../../../components/TableSkeleton.vue'

import axios from 'axios'

export default {
  name: 'FindSpeech',
  components: {
    Loading,
    TableSkeleton
  },
  data: () => {
    return {
      isLoading: false,
      items: [],
      searchTerm: '',
      fields: [
        {
          key: 'id',
          label: 'ID',
          thClass: 'text-muted small font-weight-bold align-middle text-center column-id',
          tdClass: 'align-middle text-center text-body column-id'
        },
        {
          key: 'createdAt',
          label: 'Data',
          thClass: 'text-muted small font-weight-bold align-middle text-center column-date',
          tdClass: 'align-middle text-center column-date'
        },
        {
          key: 'description',
          label: 'Descrição',
          thClass: 'text-muted small font-weight-bold align-middle column-description',
          tdClass: 'align-middle column-description'
        },
        {
          key: 'text',
          label: 'Fala',
          thClass: 'text-muted small font-weight-bold align-middle column-text',
          tdClass: 'align-middle column-text'
        },
        {
          key: 'notificationType',
          label: 'Tipo de Notificação',
          thClass: 'text-muted small font-weight-bold align-middle text-center column-notification',
          tdClass: 'align-middle text-center column-notification'
        },
        {
          key: 'setVolume',
          label: 'Config. Volume',
          thClass: 'text-muted small font-weight-bold align-middle text-center column-volume-flag',
          tdClass: 'align-middle text-center column-volume-flag'
        },
        {
          key: 'volumeLevel',
          label: 'Volume',
          thClass: 'text-muted small font-weight-bold align-middle text-center column-volume-level',
          tdClass: 'align-middle text-center column-volume-level'
        },
        {
          key: 'speechDelay',
          label: 'Delay (s)',
          thClass: 'text-muted small font-weight-bold align-middle text-center column-delay',
          tdClass: 'align-middle text-center column-delay'
        },
        {
          key: 'action',
          label: '',
          thClass: 'text-muted small font-weight-bold align-middle text-center column-actions',
          tdClass: 'align-middle text-center column-actions'
        }
      ],
      currentPage: 1,
      perPage: 10,
      isBusy: false
    }
  },
  methods: {
    redirect(ref) {
      if (ref == 'bot') {
        localStorage.removeItem('redirectBot')
        localStorage.setItem('redirectBot', '/bot-speechs')
      }

      this.$router.push(ref)
    },

    clearSearch() {
      this.searchTerm = ''
    },

    formatNotificationType(type) {
      switch (type) {
        case 1:
          return 'Fala Imediata'
        case 2:
          return 'Anúncio'
        default:
          return 'Não definido'
      }
    },

    formatDate(value) {
      if (!value) {
        return '-'
      }
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) {
        return value
      }
      const options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }
      return new Intl.DateTimeFormat('pt-BR', options).format(date)
    },

    async getNotification(title, body, type) {
      this.$vToastify.setSettings({
        position: 'bottom-center'
      })
      await this.$vtNotify({
        title: title,
        body: body,
        type: type,
        duration: 3000
      })
    },

    async getSpeechs() {
      this.isBusy = true

      const url = `${config.default.urlBase}/companies/speechs`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isBusy = false

          this.items = response.data
        }
      } catch (error) {
        console.log({
          error
        })

        this.isBusy = false
        this.isLoading = false

        this.options = []

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao buscar os tipos de fala! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async deleteSpeech(speech) {
      await this.destroySpeechs(speech.item.id)
    },

    async deleteSpeechMobile(item) {
      await this.destroySpeechs(item.id)
    },

    async editSpeech(speech) {
      this.$router.push({
        name: 'Bot',
        params: { speechData: speech.item }
      })
    },

    async editSpeechMobile(item) {
      this.$router.push({
        name: 'Bot',
        params: { speechData: item }
      })
    },

    async destroySpeechs(id) {
      this.isLoading = true

      const url = `${config.default.urlBase}/companies/speech/${id}`

      try {
        const response = await axios({
          url,
          method: 'delete',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false

          await this.$alert(`Fala excluída!`, 'Sucesso', 'success')

          this.getSpeechs()
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoading = false

        this.options = []

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao buscar os tipos de fala! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    }
  },

  computed: {
    rows() {
      return this.filteredItems.length
    },

    filteredItems() {
      if (!this.searchTerm) {
        return this.items
      }
      const term = this.searchTerm.toLowerCase()
      return this.items.filter(item => {
        const values = [item.id, item.createdAt, item.description, item.text, item.notificationType, item.volumeLevel, item.speechDelay]
        return values.filter(value => value !== undefined && value !== null).some(value => String(value).toLowerCase().includes(term))
      })
    }
  },

  watch: {
    searchTerm() {
      this.currentPage = 1
    }
  },

  async beforeMount() {
    this.isLoading = true
    this.token = sessionStorage.getItem('token')
    this.getSpeechs()
    this.isLoading = false
  }
}
